module.exports = __webpack_public_path__ + "static/img/2272_phase_function_Paper_PointsHejduk_Prediction.f22b6da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2272_phase_function_Paper_PointsHejduk_Prediction.png
// module id = wnQl
// module chunks = 0